import type { BlockAverageData } from './types';

type Props = {
  classroomAverages: BlockAverageData[];
  studentAverages: BlockAverageData[];
};

type AlignedData = {
  id: string;
  classroomAverage: number | null;
  studentAverage: number;
  blockTitle?: { text?: string };
};

export const getAlignedData = ({
  classroomAverages,
  studentAverages,
}: Props): AlignedData[] => {
  return studentAverages
    .map((studentBlock) => {
      const classroomBlock = classroomAverages.find(
        (block) => block.id === studentBlock.id
      );

      if (studentBlock?.average === null || studentBlock?.average === undefined)
        return null;

      return {
        id: studentBlock.id,
        classroomAverage: classroomBlock?.average ?? null,
        studentAverage: studentBlock.average,
        blockTitle: studentBlock.blockTitle,
      };
    })
    .filter((block): block is NonNullable<typeof block> => block !== null);
};
